import React from 'react';

const Logo: React.FC<{ isWhite?: boolean }> = ({ isWhite = false }) => {
  return (
    <div className="flex items-center">
      <img src={isWhite ? '/logoWhite.svg' : '/logo.svg'} alt="logo" className="h-10 w-auto" />
    </div>
  );
};

export default Logo;
